import React, { useState, useEffect, useCallback } from "react";

const Testimonial = () => {
  const testimonials = [
    "Working with lumetraSoftech was an absolute pleasure. Their web application development skills helped streamline our business processes, saving us time and resources. Their commitment to delivering on time and within budget was impressive. We look forward to collaborating with them on future projects. ",
    "Another working with lumetraSoftech was an absolute pleasure. Their web application development skills helped streamline our business processes, saving us time and resources. Their commitment to delivering on time and within budget was impressive. We look forward to collaborating with them on future projects. ",
    "Yet another working with lumetraSoftech was an absolute pleasure. Their web application development skills helped streamline our business processes, saving us time and resources. Their commitment to delivering on time and within budget was impressive. We look forward to collaborating with them on future projects. ",
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const showNextTestimonial = useCallback(() => {
    setCurrentTestimonial((prevIndex) => (prevIndex + 1) % testimonials.length);
  }, [testimonials.length]);

  const showPrevTestimonial = useCallback(() => {
    setCurrentTestimonial(
      (prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length
    );
  }, [testimonials.length]);

  useEffect(() => {
    const intervalId = setInterval(showNextTestimonial, 4000);

    return () => clearInterval(intervalId);
  }, [showNextTestimonial]);

  return (
    <section className="relative bg-teal-700 py-16 text-white sm:py-20">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-5 lg:px-8">
        <button
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-white/30 text-white hover:bg-white/10"
          onClick={showPrevTestimonial}
        >
          <span className="text-2xl">&#60;</span>
        </button>
        <div className="text-center sm:px-6">
          <h2 className="text-2xl font-bold sm:text-3xl">
            What our Client Says
          </h2>
          <div className="my-5 flex items-center justify-center">
            <div className="bg-white rounded-full p-2 md:p-3 inline-block">
              <span className="text-teal-700 text-lg md:text-2xl">
                &#128100;
              </span>
            </div>
          </div>
          <p className="mx-auto max-w-3xl text-sm leading-7 text-teal-50 sm:text-lg sm:leading-8">
            {testimonials[currentTestimonial]}
          </p>
        </div>
        <button
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md border border-white/30 text-white hover:bg-white/10"
          onClick={showNextTestimonial}
        >
          <span className="text-2xl">&#62;</span>
        </button>
      </div>
    </section>
  );
};

export default Testimonial;
